const FIELDS = [
  'product.category.path.name',
  'product.category.name',
  'product.brand.name',
  'store.name',
];
const FILTER_TERM_MAP = {
  category: 'product.category.path.id',
  brand: 'product.brand.name.keyword',
  store: 'store.name.keyword',
};

export default (query = '', filter = {}) => {
  const terms = query ? query.trim().split(/\s/) : []; // Split up terms for a broader match

  return {
    bool: {
      minimum_should_match: terms.length,
      should: []
        .concat(
          ...terms.map(term =>
            FIELDS.map(field => ({
              match_phrase_prefix: {
                [field]: {
                  query: term,
                },
              },
            }))
          )
        )
        .concat(
          ...terms.map(term =>
            FIELDS.map(field => ({
              match_phrase: {
                [field]: {
                  query: term,
                  boost: 3,
                },
              },
            }))
          )
        )
        .concat(
          terms.map(term => ({
            match_phrase_prefix: {
              'product.name': {
                slop: 10,
                query: term,
                boost: 2,
              },
            },
          }))
        )
        .concat(
          terms.map(term => ({
            match_phrase: {
              'product.name': {
                query: term,
                boost: 3,
              },
            },
          }))
        ),
      must: Object.keys(filter)
        .filter(term => filter[term].length > 0)
        .map(term => ({
          bool: {
            should: [].concat(
              filter[term].map(value => ({
                term: { [FILTER_TERM_MAP[term]]: value },
              }))
            ),
          },
        })),
    },
  };
};
